import { motion } from "framer-motion";
import { PawPrint, ArrowRight } from "lucide-react";
import { SPECIES_ICON } from "@/lib/stateMeta";

export function SpeciesGrid({ species, onPick }) {
  if (!species.length) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="species-grid">
      {species.map((sp, i) => (
        <motion.button
          key={sp.species}
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.32, delay: i * 0.05 }}
          onClick={() => onPick(sp)}
          className="group bg-forest text-bone p-6 flex flex-col items-start gap-4 hover:bg-forest/90 transition-colors relative overflow-hidden"
          data-testid={`species-card-${sp.species}`}
        >
          <span className="w-16 h-16 rounded-full bg-bone grid place-items-center overflow-hidden">
            {SPECIES_ICON[sp.species]
              ? <img src={SPECIES_ICON[sp.species]} alt={sp.species} width={56} height={56} loading="lazy" className="w-14 h-14 object-contain" data-testid={`species-icon-${sp.species}`} />
              : <PawPrint size={26} className="text-blaze" />}
          </span>
          <div>
            <p className="font-serif text-2xl leading-none tracking-tight">{sp.species}</p>
            <p className="text-xs text-bone/60 mt-1.5">{sp.weapons.length} method{sp.weapons.length === 1 ? "" : "s"} · {sp.hunt_count} hunt{sp.hunt_count === 1 ? "" : "s"}</p>
          </div>
          <ArrowRight size={18} className="text-blaze absolute bottom-5 right-5 opacity-0 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all" />
        </motion.button>
      ))}
    </div>
  );
}
